module.exports = __webpack_public_path__ + "img/dinersclub.205c21e6.svg";